import AccountStore from './AccountStore';
import AllShipperStore from './AllShippersStore';
import BankCardStore from './BankCardStore';

export default {
  accountStore: new AccountStore(),
  allShipperStore: new AllShipperStore(),
  bankCardStore: new BankCardStore(),
};
